import { render, staticRenderFns } from "./sampleReport.vue?vue&type=template&id=0ef86286&scoped=true&"
import script from "./sampleReport.vue?vue&type=script&lang=js&"
export * from "./sampleReport.vue?vue&type=script&lang=js&"
import style0 from "./sampleReport.vue?vue&type=style&index=0&id=0ef86286&lang=scss&scoped=true&"
import style1 from "./sampleReport.vue?vue&type=style&index=1&id=0ef86286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef86286",
  null
  
)

export default component.exports